import logoDark from '../assets/ritcco-logo-dark.png'
import logoWhite from '../assets/ritcco-logo-white.png'
import { cn } from '../lib/utils'

/** Clip the brand artwork to its arrow mark, retaining the original pixels. */
export function LogoMark({ className }: { className?: string }) {
  return <span aria-hidden="true" className={cn('inline-block h-6 w-[27px] shrink-0 overflow-hidden', className)}><img src={logoDark} alt="" draggable={false} className="h-full w-auto max-w-none" /></span>
}

/**
 * RITCCO logo with optional tagline. `tone="light"` is for dark backgrounds.
 * The arrow tail hangs below the wordmark, so the image is nudged down to center the wordmark optically.
 */
export function Logo({ tone = 'light', size = 'md', tagline = true, stacked = false, className }: { tone?: 'light' | 'dark'; size?: 'sm' | 'md' | 'lg'; tagline?: boolean; stacked?: boolean; className?: string }) {
  const height = { sm: 'h-5', md: 'h-7', lg: 'h-9' }[size]
  return (
    <span className={cn('inline-flex select-none', stacked ? 'flex-col items-start gap-2' : 'items-center gap-5 align-middle', className)}>
      <img src={tone === 'light' ? logoWhite : logoDark} alt="RITCCO" className={cn('w-auto max-w-none translate-y-[11%]', height)} draggable={false} />
      {tagline && (
        <span className={cn('whitespace-nowrap text-[10px] font-medium uppercase tracking-[0.06em]', tone === 'light' ? 'text-navy-200' : 'text-navy-700', !stacked && 'hidden md:inline')}>
          People. Technology. Progress.
        </span>
      )}
    </span>
  )
}
